<template>
	<div>
		<!--  -->
		<div class="input_list">
			<el-select v-model="memberFilter.type" style="width: 150px;margin-right: 20px;" size="small">
				<el-option v-for="item in keyss" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="memberFilter.text">
			</el-input>
			<div class="input_one">
				<div class="input_one_wen">加入会员时间</div>
				<el-date-picker size="small" v-model="memberFilter.createStartTime" type="date" placeholder="请选择日期"
					value-format="yyyy-MM-dd"></el-date-picker>
				<div style="width:35px;text-align: center;line-height: 30px;">至</div>
				<el-date-picker size="small" v-model="memberFilter.createEndTime" type="date" placeholder="请选择日期"
					value-format="yyyy-MM-dd"></el-date-picker>
			</div>
			<div class="input_one">
				<div class="input_one_wen">会员到期时间</div>
				<el-date-picker size="small" v-model="memberFilter.startTime" type="date" placeholder="请选择日期"
					value-format="yyyy-MM-dd"></el-date-picker>
				<div style="width:35px;text-align: center;line-height: 30px;">至</div>
				<el-date-picker size="small" v-model="memberFilter.endTime" type="date" placeholder="请选择日期"
					value-format="yyyy-MM-dd"></el-date-picker>
				<el-button type="primary" style="margin-left: 20px;" size="small" @click="memberList">筛 选</el-button>
				<el-button style="margin-left: 20px;" size="small" @click="memberExcel">导 出</el-button>
				<el-button type="text" size="small" @click="clearFilter">清空所有选项</el-button>
			</div>
		</div>
		<!--  -->
		<div class="usertable">
			<el-table :header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
				:cell-style="{'text-align':'center'}" ref="multipleTable" :data="tableData" tooltip-effect="dark"
				style="width: 100%">
				<el-table-column prop="userName" label="会员昵称"></el-table-column>
				<el-table-column prop="telephone" label="联系电话"></el-table-column>
				<el-table-column prop="memberTitle" label="权益卡"></el-table-column>
				<!-- <el-table-column prop="inviteName" label="邀请人" width="100">
					<template slot-scope="scope">
						{{ scope.row.inviteName==null ?'/' :scope.row.inviteName }}
					</template>
				</el-table-column>
				<el-table-column prop="storeName" label="所属门店" width="150">
					<template slot-scope="scope">
						{{scope.row.storeName==null ?'/' :scope.row.storeName}}
					</template>
				</el-table-column> -->
				<el-table-column prop="attribute" label="是否有效" width="100"></el-table-column>
				<el-table-column prop="createTime" label="加入会员时间"></el-table-column>
				<el-table-column prop="dueDate" label="会员到期日期"></el-table-column>
				<!-- <el-table-column width="130" label="操作">
					<div>
						<el-button type="text">详情</el-button>
					</div>
				</el-table-column> -->
			</el-table>
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="memberFilter.pageNum" :page-sizes="[10, 20, 50]"
					layout="total, sizes, prev, pager, next, jumper" :total="memberFilter.total"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				url: url(),
				memberFilter: {
					pageNum: 1,
					pageSize: 10,
					total: 0,
					createStartTime: undefined,
					createEndTime: undefined,
					startTime: undefined,
					endTime: undefined,
					type: 3,
					text: undefined,
				},
				keyss: [{
						label: "用户ID",
						value: 3,
					},{
						label: "手机号",
						value: 4,
					}
				],
				tableData: [],
				// tabs 数据列表
				tabs: [],
			};
		},
		methods: {
			clearFilter() {
				this.memberFilter.createStartTime = this.memberFilter.createEndTime = this.memberFilter.startTime = this
					.memberFilter.endTime = undefined;
				this.memberList();
			},
			handleSizeChange(val) {
				this.memberFilter.pageSize = val;
				this.memberList();
			},
			handleCurrentChange(val) {
				this.memberFilter.pageNum = val;
				this.memberList();
			},
			memberExcel() {
				let str = "?createStartTime=" + this.memberFilter.createStartTime +
					"&createEndTime=" + this.memberFilter.createEndTime +
					"&startTime=" + this.memberFilter.startTime +
					"&endTime=" + this.memberFilter.endTime;
				window.location.assign(this.url + "member/excel" + str);
			},
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) => (i === id ? (v.isActive = true) : (v.isActive = false)));
			},
			memberList() {
				this.$http.post('member/list', JSON.stringify(this.memberFilter)).then(res => {
					this.tableData = res.body.data;
					this.memberFilter.total = res.body.total;
				});
			}
		},
		mounted() {
			this.memberList();
		},
	};
</script>

<style lang="less" scoped>
	/deep/ .yxlabel {
		width: 20px;
		overflow: hidden;
	}

	.demotops {
		margin-bottom: 20px;
		width: 100%;
		height: 250px;
		background: #ECECEC;
		display: flex;
		padding: 30px;
		box-sizing: border-box;

		.demo1_card {
			width: 313px;
			height: 190px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.demo1_price {
			box-sizing: border-box;
			padding-top: 20px;
			margin-left: 40px;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #444343;
			flex: 1;

			>div {
				&:nth-child(2) {
					margin-top: 15px;
				}
			}
		}

		.demo1_botton {
			margin-top: 80px;
		}

		// opacity: 0.51;
	}

	//输入框列表
	.input_list {
		.input_one {
			display: flex;

			&:nth-child(n + 2) {
				margin-top: 20px;
			}

			.input_one_wen {
				padding-left: 10px;
				line-height: 30px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #3e3e3e;
				width: 100px;
			}
		}
	}

	// 页码器
	.pagescg {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 表格
	.usertable {
		width: 100%;
		margin-top: 20px;

		.table_title {
			margin-bottom: 8px;
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #c9c9c9;
			width: 100%;
			text-align: right;
		}
	}

	.tablie_select {
		margin-top: 10px;
		display: flex;

		div {
			line-height: 30px;
		}
	}
</style>